var _path, _path2, _rect, _g, _rect2, _rect3, _rect4, _rect5, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPlaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 149,
    viewBox: "0 0 176 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.7388 31.0547C72.7388 24.9795 77.6636 20.0547 83.7388 20.0547H163.512V137.7C163.512 143.775 158.587 148.7 152.512 148.7H72.7388V31.0547Z",
    fill: "#FFCF85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.102 20.0547H164.535C170.61 20.0547 175.535 24.9796 175.535 31.0547V63.7589C175.535 69.834 170.61 74.7589 164.535 74.7589H158.102V20.0547Z",
    fill: "#FFCF85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.3687,
    y: 41.0938,
    width: 59.5134,
    height: 16.2309,
    fill: "#FFF2DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2718_6594)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.304688,
    width: 100.088,
    height: 132.713,
    rx: 4,
    fill: "#F4F4F4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4331,
    y: 59.1094,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4331,
    y: 71.4141,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4331,
    y: 83.7188,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4331,
    y: 96.0312,
    width: 46.8893,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0151 30.8135V31.9053C40.0088 33.3525 40.0088 34.9775 39.5454 37.4277L37.9204 37.2627C38.3647 35.0791 38.3838 33.4541 38.3901 32.0957H31.5854V30.8135H40.0151ZM30.4937 39.9541V38.6338H34.2642V34.6602H35.8765V38.6338H41.0308V39.9541H30.4937ZM55.3003 38.6846V39.9795H44.7251V38.6846H49.1431V36.0693H50.7554V38.6846H55.3003ZM44.979 35.0918C47.5942 34.6855 49.0669 32.9272 49.0796 31.2959V30.4707H50.8062V31.2959C50.7998 32.9463 52.2915 34.6855 54.9321 35.0918L54.2466 36.4375C52.2153 36.0693 50.7046 34.9839 49.9429 33.543C49.1875 34.9775 47.6831 36.0757 45.6646 36.4375L44.979 35.0918ZM65.52 30.585V31.8799H63.2222C63.2285 33.2256 64.0474 34.5269 65.8882 35.0664L65.1138 36.3359C63.8379 35.9487 62.9492 35.168 62.4414 34.1841C61.9272 35.3457 60.9878 36.2725 59.604 36.7295L58.7788 35.4473C60.6958 34.8442 61.5654 33.3462 61.5845 31.8799H59.2231V30.585H65.52ZM60.3784 39.1162C60.3721 37.707 61.8955 36.8882 64.3394 36.8945C66.7451 36.8882 68.2305 37.707 68.2368 39.1162C68.2305 40.5317 66.7451 41.3696 64.3394 41.3633C61.8955 41.3696 60.3721 40.5317 60.3784 39.1162ZM62.0034 39.1162C61.9907 39.7764 62.8223 40.1064 64.3394 40.1064C65.8374 40.1064 66.6372 39.7764 66.6372 39.1162C66.6372 38.4688 65.8374 38.145 64.3394 38.1514C62.8223 38.145 61.9907 38.4688 62.0034 39.1162ZM66.4976 36.666V29.8105H68.1226V32.4893H69.6841V33.8096H68.1226V36.666H66.4976Z",
    fill: "#374969"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2718_6594",
    x: 0,
    y: 0.304688,
    width: 108.087,
    height: 140.711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2718_6594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2718_6594",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlaint);
export default __webpack_public_path__ + "static/media/IcPlaint.a92bf8577512301559cd69575c7a1289.svg";
export { ForwardRef as ReactComponent };